import { SocialTab, SocialTabType } from '@/models/Social/Profile/social-tab';
import { BlockStruct } from '@/models/Blocks/block-struct';
import { TemplateStruct } from "@/models/Blocks/Itens/Types/template-struct";
import { BlockFactory } from "@/models/Blocks/Itens/block-factory";
import { BlockProduct } from '@/models/Blocks/Itens/block-product';
import { BlockItem } from "@/models/Blocks/Itens/block-item";
import request from '@/Utilities/httpRequest';

export class SocialTabProducts extends SocialTab {
    protected _structs: Array<TemplateStruct> = [];
    protected _nextpage: number|null = 1;
    protected _isLoading: boolean = false;
    protected _products: Array<BlockProduct> = [];

    protected _data(value: any){
        let products = value.elements ?? null;
        let struct   = products && products.length && this._templateStruct(products);
        if(products) {
            this._addProducts(products);
        }
        if(struct){
            this._structs.push(struct);
            this._nextpage = value.nextpage ?? null;
        }else{
            this._nextpage = null;
        }
    }
    
    public async nextPage() {
        let params: any = this._getParams();
        if(this._isLoading){
            return false;
        }
        if(this._url && this._nextpage && params){
            this._isLoading = true;
            let { data } = await request.post(this._url,params,false);
            this._data(data);
            this._isLoading = false;
        }
    }

    public get isLoading(): boolean {
        return this._isLoading;
    }

    public hasContent(): boolean{
        return this._structs.length > 0;
    }

    public hasNextPage(): boolean{
        return this._nextpage != null;
    }

    protected _getParams(): any|undefined {
        if(this._nextpage === null){
            return undefined;
        }
        return {...this._params,...{page:this._nextpage}};
    }

    // protected _getBlockName(): string {
    //     let params = this._getParams();
    //     if(params?.profile??null){
    //         return 'SOCIAL_PROFILE_PRODUCTS';
    //     }
    //     if(params?.postId??null){
    //         return 'SOCIAL_POST_PRODUCTS';
    //     }
    //     return '';
    // }

    protected _templateStruct(data: Array<object>): TemplateStruct {
        const block = new BlockStruct('LIST', data, true);
        //block.blockName = this._params && this._params.oti ? this._params.oti : null;
        return block.getStruct();
    }

    protected _addProducts(data: Array<object>){
        data.forEach(p => {
            let item: BlockItem|null = BlockFactory.get(p);
            if(item instanceof BlockProduct){
                this._products.push(item);
            }
        });
    }

    public getProducts(): Array<BlockProduct>{
        return this._products;
    }

    public getData():Array<TemplateStruct>{
        if(this._isLoading){
            let l = new BlockStruct('LOADINGLIST',[]);
            l.skeleton = true;
            return [...this._structs,l.getStruct()];
        }
        return this._structs;
    }

    public get type(): SocialTabType{
        return SocialTabType.blocks;
    }
}